import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useSaveAvatar } from '../hooks/useSaveAvatar';
import { testS3UploadEndpoint } from '../utils/s3TestUtils';
import { useAppStore } from '../../../store';
import type { AvatarComposition } from '../types/types';
import type { AvatarCanvasRef } from './AvatarCanvas';
import './SaveAvatarButton.css';

interface SaveAvatarButtonProps {
  avatarComposition: AvatarComposition;
  canvasStageRef: React.RefObject<AvatarCanvasRef>;
  onSaveSuccess?: () => void;
}

export const SaveAvatarButton: React.FC<SaveAvatarButtonProps> = ({
  avatarComposition,
  canvasStageRef,
  onSaveSuccess
}) => {
  const [s3Status, setS3Status] = useState<'checking' | 'available' | 'unavailable'>('checking');
  const [savingStatus, setSavingStatus] = useState<string>('');
  const { saveAvatar, isSaving } = useSaveAvatar();
  const { user } = useAppStore();
  const navigate = useNavigate();
  
  
  const avatarName = user?._id ? `Avatar_${user._id}` : `Avatar_${new Date().getTime()}`;

  
  useEffect(() => {
    const checkS3Status = async () => {
      try {
        const result = await testS3UploadEndpoint();
        setS3Status(result.isAvailable ? 'available' : 'unavailable');
        
        if (!result.isAvailable) {
                  } else {
                  }
      } catch (error) {
                setS3Status('unavailable');
      }
    };

    checkS3Status();
  }, []);

  const getButtonTitle = () => {
    if (s3Status === 'checking') {
      return 'Verificando conectividad S3...';
    } else if (s3Status === 'unavailable') {
      return 'Guardar Avatar (S3 no disponible, usando fallback)';
    } else {
      return 'Guardar Avatar y Foto de Perfil en S3';
    }
  };

  const handleSaveClick = async () => {
    const itemsToSave = avatarComposition.filter(item => item.category !== 'base');
    
    if (itemsToSave.length === 0) {
      setSavingStatus('Escolha pelo menos 1 item para continuar.');
      setTimeout(() => setSavingStatus(''), 1800);
      return;
    }

    if (!canvasStageRef.current) {
      return;
    }

    const stage = canvasStageRef.current.getStage();
    if (!stage) {
      return;
    }

    try {
      setSavingStatus('Guardando avatar...');
      await saveAvatar(avatarComposition, stage as any, avatarName);
      setSavingStatus('Avatar guardado!');
      
      setTimeout(() => {
        if (onSaveSuccess) {
          onSaveSuccess();
          return;
        }
        navigate('/');
      }, 500);
    } catch (err) {
      setSavingStatus('');
    }
  };

  return (
    <button
      className="save-button"
      onClick={handleSaveClick}
      disabled={isSaving}
      title={getButtonTitle()}
    >
      {isSaving || savingStatus ? (savingStatus || 'Guardando...') : 'GUARDAR'}
    </button>
  );
};

export default SaveAvatarButton;
